import { render } from "./ValidationAnnotationsTable.vue?vue&type=template&id=627d2cd8&scoped=true&ts=true"
import script from "./ValidationAnnotationsTable.vue?vue&type=script&lang=ts"
export * from "./ValidationAnnotationsTable.vue?vue&type=script&lang=ts"

import "./ValidationAnnotationsTable.vue?vue&type=style&index=0&id=627d2cd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627d2cd8"]])

export default __exports__